import { render, staticRenderFns } from "./DefaultDocumentView.vue?vue&type=template&id=ad29e816&"
import script from "./DefaultDocumentView.vue?vue&type=script&lang=ts&"
export * from "./DefaultDocumentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports